import { render, staticRenderFns } from "./VirtualScroll.vue?vue&type=template&id=5f0e082a&scoped=true&"
import script from "./VirtualScroll.vue?vue&type=script&lang=ts&"
export * from "./VirtualScroll.vue?vue&type=script&lang=ts&"
import style0 from "./VirtualScroll.vue?vue&type=style&index=0&id=5f0e082a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0e082a",
  null
  
)

export default component.exports